import {
  Component,
  OnInit,
  Input,
  forwardRef,
  OnDestroy,
  Output,
  EventEmitter,
  ElementRef,
  OnChanges,
  SimpleChanges} from '@angular/core';
import { UtilService } from '../../services/util.service';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelectDropdownItem } from 'mis-crystal-design-system/multi-select-dropdown';

@Component({
  selector: 'app-dropdown-checkbox',
  templateUrl: './dropdown-checkbox.component.html',
  styleUrls: ['./dropdown-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownCheckboxComponent),
      multi: true
    }
  ]
})
export class DropdownCheckboxComponent extends BaseControlValueAccessor<any> implements OnInit, OnDestroy, OnChanges {

  @Input() options: any[];
  @Input() label: string;
  @Input() recipientType: string;
  @Input() formControl: FormControl;
  @Input() getCustomOptionValue: (arg0: any) => string;
  @Input() getCustomOptionLabel: (arg0: any) => string;
  @Input() width: string;
  @Input() dropdownListWidth: string;
  @Output() changeCallback = new EventEmitter();

  selectedItems: Array<MultiSelectDropdownItem> = [];
  @Output() selectedItemLength = new EventEmitter();

  public optionList: any[];
  public isListShown = false;
  public selectedOptions: any[] = [];
  public activeOption: any;

  constructor(
      private utilService: UtilService,
      private elementRef: ElementRef,
    ) {
    super();
  }

  ngOnInit() {
    this.options.forEach((element) => {
      element.selected = true;
    });
    if (this.formControl.status === "VALID") {
      this.selectedOptions = this.formControl.value;
    }
    const data = this.utilService.deepCopy(this.options);
    this.optionList = data.map(option => {
      return {
        label: this.getCustomOptionLabel(option),
        value: this.getCustomOptionValue(option)
      };
    });
    if (this.formControl) {
      this.formControl.valueChanges.subscribe(this.formControlChange);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.recipientType) {
      if (this.formControl.valid) {
        const data = this.utilService.deepCopy(this.options);
        this.optionList = data.map(option => {
          return {
            label: this.getCustomOptionLabel(option),
            value: this.getCustomOptionValue(option)
          };
        });
      }
    }
  }

  formControlChange = () => {
    this.selectedOptions = this.formControl.value;
  }

  setValue() {
    this.onChange(this.selectedOptions);
    if (this.changeCallback) {
      this.changeCallback.emit(this.selectedOptions);
    }
  }

  getOptionValue(option) {
    return typeof option === 'string' ? option : this.getCustomOptionValue(option);
  }

  getOptionLabel(option) {
    return typeof option === 'string' ? option : this.getCustomOptionLabel(option);
  }

  onOptionSelect(option, event) {
    option.selected = event.checked;
    if (option.selected) {
      this.selectedOptions.push(event.value);
    } else {
      const index = this.selectedOptions.indexOf(option.value);
      this.selectedOptions.splice(index, 1);
    }
    this.setValue();
  }

  onTriggerClick = (e: Event) => {
    this.isListShown = !this.isListShown;
  }

  hideList = () => {
    this.isListShown = false;
    this.activeOption = undefined;
  }

  setHighlightedOption(event) {
    if (event && event.keyCode === 40) {
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption < this.optionList.length - 1)
                            ? (this.activeOption + 1) : 0;
      this.scrollToActiveOption();
    } else if (event && event.keyCode === 38) {
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption > 0)
                            ? (this.activeOption - 1) : this.optionList.length - 1;
      this.scrollToActiveOption();
    } else if (event && (event.keyCode === 9 || event.keyCode === 27)) {
      this.hideList();
    } else if (event && event.keyCode === 13 && typeof this.activeOption === 'number' && this.isListShown) {
      this.onOptionSelect(this.optionList[this.activeOption], {
        checked: !this.optionList[this.activeOption].selected
      });
    }
  }

  checkValue(e) {
    this.selectedItems = e;
    this.selectedItemLength.emit(this.selectedItems.length);

    // let data;
    // if(this.selectedItems && this.selectedItems.length) {
    //   data = this.selectedItems.map(item => item.value);
    // }
    // this.onChange(data);
    // if(this.label == "Booking Type" || this.label == "Offices" || this.label == "City" || this.label == "Vendor/Cab Status"  ) {
    //   this.handleApplyFilters.emit();
    // }
  }

  scrollToActiveOption() {
    const parent = this.elementRef.nativeElement;
    parent.getElementsByClassName('dropdown-option')[this.activeOption].scrollIntoView({block: 'nearest'});
  }

  clickOutside() {
    this.isListShown = false;
  }


  ngOnDestroy() {

  }

  showError() {
    return Boolean(this.formControl &&  this.formControl.dirty && this.formControl.errors);
  }

}
